<div class="out"  kzLib (click)="clickDbg()">
  <div class="bar1 green" *ngIf="!bNoSound && remote_audio" [style.top.px]="bars[0].top" [style.height.px]="bars[0].height"></div>
  <div class="bar1 bar2 green" *ngIf="!bNoSound && remote_audio" [style.top.px]="bars[1].top" [style.height.px]="bars[1].height"></div>
  <div class="bar1 bar3 green" *ngIf="!bNoSound && remote_audio" [style.top.px]="bars[2].top" [style.height.px]="bars[2].height"></div>
  <img class="abs_center" src="assets/images/mic_off.svg" *ngIf="bNoSound || !remote_audio" alt="">
</div>
